<template>
  <form @submit.prevent="handleSubmit" autocomplete="off">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Es necesario que valides el código que enviamos a tu correo</p>
      </header>
      <section class="modal-card-body">

        <div class="content">
          <p>Por politicas de seguridad es necesario que valides la doble autenticación de tu cuenta</p>
          <p>Para esto necesitas consultar el correo de la sucursal</p>
          <div>
            <b-field label="Código de validación" :type="errors.password ? 'is-danger' : null" :message="errors.password ? errors.password : null">
              <b-input
                  type="text"
                  :value="password"
                  placeholder="000000"
                  maxlength="6"
                  v-model="password"
                  name="password"
                  minlength="6"
                  required>
              </b-input>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
            :disabled="hasErrors"
            native-type="submit"
            label="Validar código"
            type="is-primary" />
        <b-button
          native-type="button"
          @click="$auth.logout().then(() => {$emit('close')})"
          label="Cerrar sesión"
          type="is-danger is-light" />
      </footer>
    </div>
  </form>
</template>

<script>
import UpdatePasswordModal from "./UpdatePasswordModal.vue";

export default {
  name: "ActivateMFAModal",
  data() {
    return {
      password: '',
      errors: {}
    }
  },
  computed: {
    hasErrors() {
      return (Object.keys(this.errors).length > 0);
    }
  },
  methods: {
    handleSubmit() {
      if(this.password.length === 6){
        this.$loader.show();
        this.$http.post('validate_mfa_email', {password: this.password}).then(() => {
          this.$toast.success('Código de validación correcto');
          localStorage.setItem('lapi-validated-mfa', 1);
          this.$emit('close');
          if(this.$auth.user().update_password){
            this.$buefy.modal.open({
              parent: this,
              component: UpdatePasswordModal,
              hasModalCard: true,
              trapFocus: true,
              canCancel: false
            });
          }
        }).catch(errors => {
          this.$buefy.dialog.alert({
            title: 'Fallo al validar la doble autenticación',
            message: errors.response.data.message
          })
        }).finally(() => {
          this.$loader.hide();
        })
      }
    },
  }
}
</script>

<style scoped>
.modal-mfa-qr {
  width: 250px;
  height: 250px;
}
</style>